module.exports = __webpack_public_path__ + "img/logo_sporthorse.58f2d2dd.png";